module.exports = __webpack_public_path__ + "static/r28-4d332ded09c9c3d9c4d481748c72e59b.jpg";